export const blockingColors = {
  actionBlue: '#000FFF',
  brandBlue: '#0B29FB',
  alertBg: '#FFCCCC',
  alertIcon: '#FF2929',
  surface: '#F2F2F2',
  pageBg: '#EFF0F0',
  iconCircle: '#D9D9D9',
  iconGlyph: '#8C8C8C',
  text: '#3D3D3D',
  textStrong: '#262626',
  textTitle: '#000000',
  tagText: '#330000',
  dashed: '#D9D9D9',
  white: '#FFFFFF',
} as const;

export const blockingMetrics = {
  cardGap: '10px',
  cardGapMobile: '32px',
  actionHeight: '48px',
  actionWidth: '267px',
  actionMaxWidth: '340px',
  iconSize: '48px',
  cardTextWidth: '406px',
  radius: '8px',
  radiusContainer: '12px',
  radiusPill: '1000px',
  mobileBreakpoint: '768px',
} as const;

export const blockingTypography = {
  fontFamily: "'Mangueira', sans-serif",
  pageTitle: { size: '24px', weight: 700, lineHeight: '37px' },
  pageSubtitle: { size: '14px', weight: 400, lineHeight: '22px' },
  cardTitle: { size: '16px', weight: 700, lineHeight: '25px' },
  cardBody: { size: '12px', weight: 400, lineHeight: '19px' },
  actionLabel: { size: '16px', weight: 700, lineHeight: '24px' },
  modalTitle: { size: '20px', weight: 600, lineHeight: '26px' },
  modalBody: { size: '16px', weight: 400, lineHeight: '24px' },
  alertText: { size: '12px', weight: 400, lineHeight: '18px' },
} as const;

export default {
  colors: blockingColors,
  metrics: blockingMetrics,
  typography: blockingTypography,
};
